import * as React from 'react';
import { SVGProps } from 'react';

const IconFacebookSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 8A6 6 0 1 0 2 8a6 6 0 0 0 6 6c.035 0 .07 0 .105-.002v-4.67H6.816V7.828h1.29V6.72c0-1.282.782-1.98 1.926-1.98.549 0 1.02.04 1.155.058V6.14H10.4c-.621 0-.743.295-.743.729v.956h1.488l-.194 1.503H9.657v4.441A6.002 6.002 0 0 0 14 8Z" />
  </svg>
);
export default IconFacebookSizeS;
